export default __webpack_public_path__ + "static/media/check-icon.bbfd02c6.svg";